import ReferralsListPage from './ReferralsListPage';

export default ReferralsListPage;
